import React from 'react';

function AboutSection() {
    const stats = [
        { number: "10+", label: "Лет на рынке" },
        { number: "5000+", label: "Проектов" },
        { number: "20+", label: "Сотрудников" },
        { number: "до 10", label: "Лет гарантии" }
    ];

    return (
        <section id="about" className="about-section">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="section-title">О нашей компании</h2>
                    <p className="section-subtitle">Профессионализм и качество с 2013 года</p>
                </div>
                <div className="row align-items-center">
                    <div className="col-lg-6 mb-4 mb-lg-0 animate-on-scroll">
                        <h3 className="mb-4 fw-bold">Почему выбирают нас?</h3>
                        <p className="about-text">
                            Компания "K2" - лидер в установке натяжных потолков в регионе.
                            За 10 лет работы мы выполнили более 5000 проектов различной сложности.
                            Используем только качественные материалы от проверенных производителей
                            и предоставляем гарантию до 10 лет.
                        </p>
                        <p className="about-text">
                            Наша команда состоит из опытных специалистов, которые регулярно
                            повышают квалификацию. Мы следим за современными трендами в дизайне
                            интерьеров и предлагаем актуальные решения.
                        </p>
                    </div>
                    <div className="col-lg-6 animate-on-scroll">
                        <div className="row g-4">
                            {stats.map((stat, index) => (
                                <div key={index} className="col-6">
                                    <div className="stat-box">
                                        <span className="stat-number">{stat.number}</span>
                                        <span className="stat-label">{stat.label}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutSection;